import { Box, Typography } from '@mui/material'
import React from 'react'
import { lightBlue } from 'src/utils/colors'
import { footerLinks } from './enums'
import FooterLink from './FooterLink'

const Footer = () => {
  return (
    <Box
      sx={{
        px: { xs: 3, md: 20 },
        pt: { xs: 3, md: 4 },
        pb: 1,
        backgroundColor: '#fff',
        borderTop: `1px solid ${lightBlue}`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          maxWidth: { xs: 'fit-content', md: 'initial' },
        }}
      >
        {footerLinks.map((footerLink, index) => (
          <FooterLink {...footerLink} key={index} />
        ))}
      </Box>
      <Box sx={{ mt: { xs: 0, md: 4 }, textAlign: 'center' }}>
        <Typography fontSize="small">
          InfoGIS © All Right Reserved by infogis.net
        </Typography>
      </Box>
    </Box>
  )
}

export default Footer
